export default "__VITE_ASSET__CjtNxTdV__"